export const AVAILABLE = "Available";
export const ACCEPTED = "Accepted";
export const ASSIGNED = "Assigned";
export const SUBMITTED = "Submitted";
export const APPROVED = "Approved";
